export enum CanvasErrorType {
  DYNAMIC_IMPORT_ERROR = 'DynamicImportError',
  RECOVERABLE_WEB_GL_ERROR = 'RecoverableWebGlError',
  UNRECOVERABLE_WEB_GL_ERROR = 'UnrecoverableWebGlError',
  ANONYMOUS_NOT_SUPPORTED_ERROR = 'AnonymousNotSupportedError',
  TENANT_ID_MISSING_ERROR = 'TenantIdMissingError',
  IDENTITY_USER_FAILED_ERROR = 'IdentityUserFailedError',
  CANVAS_RENDERER_ERROR = 'CanvasRendererError',
  SHADER_COMPILATION_ERROR = 'ShaderCompilationError',
  NO_SESSION_DATA_ERROR = 'NoSessionDataError',
  RUNTIME_ASSERTION_ERROR = 'RuntimeAssertionError',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

/**
 * An enum defining unique identifiers for all non-fatal errors
 * that we want track in Sentry and (soon) use to fail experiences.
 *
 * These can be made coarsely or finely as needed.
 * If altering these, please review their uses in `experiences.ts`.
 */
export enum CanvasNonFatalError {
  TABLE_STRUCTURE_MUTATION = 'TABLE_STRUCTURE_MUTATION',
  COMMENT_STORE = 'COMMENT_STORE',
  JIRA_ISSUE_CREATE = 'JIRA_ISSUE_CREATE',
  JIRA_ISSUE_LINK_CREATE = 'JIRA_ISSUE_LINK_CREATE',
  JIRA_ISSUE_LINK_DELETE = 'JIRA_ISSUE_LINK_DELETE',
  AI_GENERATE_STICKIES = 'AI_GENERATE_STICKIES',
  ON_DEMAND_RENDER = 'ON_DEMAND_RENDER',
  PRIVATE_MODE_CONTENT_DROPPED = 'PRIVATE_MODE_CONTENT_DROPPED',
  PRIVATE_MODE_PUBLIC_LINK = 'PRIVATE_MODE_PUBLIC_LINK',
  TEMPLATE_NO_DATA = 'TEMPLATE_NO_DATA',
  SMART_SECTION_JIRA_ISSUE_UPDATE = 'SMART_SECTION_JIRA_ISSUE_UPDATE',
  SMART_SECTION_SUBMIT = 'SMART_SECTION_SUBMIT',
}

export type ErrorType = {
  type: CanvasErrorType;
  isRecoverable: boolean;
};

export type IdentifiedError = {
  error: Error;
  type: CanvasErrorType;
  isRecoverable: boolean;
  sentryErrorId?: string;
  ignoreUfoReporting?: boolean;
};
